// src/components/ConfirmModal/ConfirmModal.jsx
import './ConfirmModal.css';

const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel  = 'Cancel',
  confirmType  = 'primary',   // 'primary' | 'danger' | 'success'
  onConfirm,
  onClose,
  children,                   // optional extra content (e.g. reason input)
}) => {
  if (!isOpen) return null;

  return (
    <div className="cm-overlay" onClick={onClose}>
      <div className="cm-modal" onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="cm-header">
          <h5 className="cm-title">{title}</h5>
          <button className="cm-close" onClick={onClose}>×</button>
        </div>

        {/* Body */}
        <div className="cm-body">
          {message && <p className="cm-message">{message}</p>}
          {children}
        </div>

        {/* Footer */}
        <div className="cm-footer">
          <button className="cm-btn-cancel" onClick={onClose}>
            {cancelLabel}
          </button>
          <button
            className={`cm-btn-confirm cm-btn-${confirmType}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;